/**
 * if file bigger that this size user will be see notification
 * "Starting to parse the file, please wait."
 * @constant
 * @type {number}
 */
export const notificationFileSize = 1000000; // 1 MB

/**
 * If the number of values is greater that this value user cant manual edit.
 * It used on list-history, list-edit, list-create pages.
 * @constant
 * @type {number}
 */
export const maxManualEditableValues = 2000;

/**
 * File import importStrategies.
 * It's dropdown values.
 * @constant
 * @type {array}
 */
export const importStrategies = [
    {
        label: 'Upload CSV and add to values',
        value: 'add',
    },
    {
        label: 'Upload CSV and replace values',
        value: 'replace',
    },
    {
        label: 'Upload CSV and remove values',
        value: 'remove',
    },
];
